<template>
  <EduBookComponent />
</template>

<script>
import EduBookComponent from "../components/Book/EduBookComponent";

export default {
  name: "EduBook",
  components: { EduBookComponent },
};
</script>

<style scoped>
</style>
